import { ProjectType } from "../Types/ProjectType";

const projectState = {
  project: {
    image: "",
    description: "",
    title: "",
    link: "",
    name: "",
    tools: [],
    overView: [],
  },
};

export const projectReducer = (state = projectState, { type, payload }) => {
  switch (type) {
    case ProjectType.PROJECTCOUNT:
      return {
        ...state,
        project: payload,
      };
    default:
      return state;
  }
};
